var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogbookUserDefined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#12908D",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.305 17.2l-9.067-5.236c-.495-.285-1.042-.318-1.458-.087 0 0-5.298 1.993-5.641 2.587-.343.595.58 6.18.58 6.18.008.475.31.932.804 1.218l9.067 5.235c.778.449 1.781.18 2.23-.598l4.082-7.07a1.638 1.638 0 00-.598-2.23zm-13.426.66a1.5 1.5 0 101.5-2.597 1.5 1.5 0 00-1.5 2.598z",
    fill: "#4A5862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.305 14.2l-9.067-5.235c-.495-.286-1.042-.319-1.458-.088 0 0-5.298 1.993-5.641 2.587-.343.595.58 6.18.58 6.18.008.475.31.932.804 1.218l9.067 5.235c.778.449 1.781.18 2.23-.598l4.082-7.07a1.638 1.638 0 00-.598-2.23zm-13.426.66a1.5 1.5 0 101.5-2.597 1.5 1.5 0 00-1.5 2.598z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogbookUserDefined);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconLogbookUserDefined.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };